import React, { useMemo, useState } from 'react'
import SearchFromTheList from '../../../../../generic/customSearchComponents/SearchFromTheList'
import { IProblemListItem } from '../../../../../modules/API/TeudotProblems/models/problems'

type Props = {
  list: IProblemListItem[]
  defaultID: number
  setProblemType: React.Dispatch<React.SetStateAction<number>>
  required?: boolean
  placeholder?: string
  disabled?: boolean
}

const SearchProblem = ({
  list,
  defaultID,
  setProblemType,
  required,
  placeholder,
  disabled
}: Props) => {
  const defaultProblem = list.filter(item => item.Code === defaultID)[0]
  const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
  const [selectedProblem, setSelectedProblem] = useState<IProblemListItem | null>(defaultProblem || null)
  const [search, setSearch] = useState<string>(defaultProblem?.Description?.trim() || '')

  const handleSearch = (e: string) => {
    if (disabled) return
    if (e === '') {
      setSelectedProblem(null)
      setProblemType(0)
      setIsOpenDropDown(false)
      setSearch('')
      return
    }
    setIsOpenDropDown(true)
    setSearch(e)
  }

  const handleSelect = (item: IProblemListItem) => {
    if (disabled) return
    setProblemType(item.Code)
    setSearch(item.Description.trim())
    setSelectedProblem(item)
    setIsOpenDropDown(false)
  }

  const render = useMemo(() => {
    if (!list) return []
    return list.filter(item =>
      item.Description?.trim().toLowerCase().includes(search.toLowerCase())
    )
  }, [list, search])

  return (
    <SearchFromTheList
      isOpenList={isOpenDropDown}
      placeHolder={placeholder || 'בחר סוג פניה'}
      list={render}
      selectFunc={handleSelect}
      searchFunc={handleSearch}
      isNeedFullObject
      input={search}
      itemDisplayName='Description'
      nameIdElement='Code'
      required={required}
      size={'full'}
      disabled={disabled}
    />
  )
}

export default SearchProblem 